module.exports = __webpack_public_path__ + "static/media/picto-message-white.c4a8cadc.svg";